import styled from "@emotion/styled";

 export const Hr = styled.hr`
 border-top: 1px solid rgb(219, 214, 214);
`;